import { createTheme } from "@material-ui/core/styles";

// Variables
let variables = {
  border: {
    primary: "rgb(213, 205, 205)",
  },
  text: {
    primary: "#16191f",
    secondary: "#0028fa",
  },
};

// default theme
const theme = createTheme();

export const customTheme = createTheme({
  mainContent: {
    width: "100%",
    maxWidth: theme.breakpoints.values.lg,
    padding: "15px 0px",
  },
  mainContentMD: {
    width: "100%",
    maxWidth: "1020px",
    padding: "15px 45px",
    margin: "0 auto",
  },
  mainContentLG: {
    width: "100%",
    maxWidth: "1240px",
    padding: "15px 45px",
    margin: "0 auto",
  },
  overrides: {
    MuiFormHelperText: {
      root: { fontFamily: ['"Source Sans Pro"', "sans-serif"].join(", ") },
    },
    MuiButton: {
      contained: {
        boxShadow: "none",
        "&:hover, &:active, &:focus": {
          boxShadow: "none",
        },
      },
    },
    MuiDivider: {
      vertical: {
        alignSelf: "stretch",
        height: "auto",
        margin: "0 0.5rem",
      },
    },
    MuiTableHead: {
      root: { background: "#F2F5F7", textTransform: "uppercase" },
    },
    MuiTableContainer: {
      root: { overflowX: "unset" },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "#f7f7f8",
          fontWeight: 700,
          borderRadius: "15px 0px 0px 15px",
        },
      },
    },
    MuiCheckbox: {
      root: {
        color: "#0765FF",
        width: "30px",
        height: "30px",
      },
    },
  },
  palette: {
    primary: {
      light: "#333f4c",
      main: "#0765FF",
      dark: "#6d7b8a",
      contrastText: "#fff",
    },
    secondary: {
      light: "#972f21",
      main: "#181818",
      dark: "#e06959",
      contrastText: "#fff",
    },
    yellow: {
      light: "#d7e360",
      main: "#cddc39",
      dark: "#8f9a27",
      contrastText: "#16191f",
    },
    green: {
      light: "#357a38s",
      main: "#16191f",
      dark: "#6fbf73",
      contrastText: "#fff",
    },
    text: {
      primary: "#16191f",
    },
  },
  typography: {
    h1: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "18px",
      lineHeight: "26px",
      margin: 0,
      padding: 0,
    },
    h2: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "16px",
      lineHeight: "19px",
      margin: 0,
      padding: 0,
    },
    hlg: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "24px",
      lineHeight: "32px",
      margin: 0,
      padding: 0,
    },
    hxl: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "32px",
      lineHeight: "42px",
      margin: 0,
      padding: 0,
    },
    fontFamily: ['"Mulish"', "sans-serif"].join(", "),
    body1: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "14px",
      lineHeight: "19px",
      fontWeight: 400,
      margin: 0,
      padding: 0,
      color: variables.text.primary,
    },
    body2: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: 400,
      margin: 0,
      padding: 0,
      color: variables.text.primary,
    },
    body3: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "11px",
      lineHeight: "16px",
      fontWeight: 400,
      margin: 0,
      padding: 0,
      color: variables.text.primary,
    },
    secondaryFontFamily: ['"Source Code Pro"', "monospace"].join(", "),
    caption: {
      fontFamily: ['"Source Code Pro"', "monospace"].join(", "),
      fontSize: "0.85rem",
      margin: 0,
      padding: 0,
    },
    color: "#495B6D",
    bold: {
      fontWeight: 800,
    },
    semiBold: {
      fontWeight: 700,
    },
    breadCrumb: {
      fontFamily: ['"Mulish"', "sans-serif"].join(", "),
      fontSize: "14px",
      lineHeight: "22px",
      fontWeight: 400,
      margin: 0,
      padding: 0,
    },
  },
  background: {
    primary: "#F7F8FA",
  },
  borderBottom: {
    borderBottom: `1px solid ${variables.border.primary}`,
  },
  borderTop: {
    borderTop: `1px solid ${variables.border.primary}`,
  },
  borderRight: {
    borderRight: `1px solid ${variables.border.primary}`,
  },
  borderLeft: {
    borderLeft: `1px solid ${variables.border.primary}`,
  },
  border: {
    border: `1px solid ${variables.border.primary}`,
  },
  primaryColor: {
    color: variables.text.primary,
  },
  secondaryColor: {
    color: variables.text.secondary,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
});
